import { useQuery } from "@tanstack/react-query";

import { getRequestFiles } from "../application/useCases/getRequestFiles";

export const createUseRequestFiles = ({ vacationRequestsRepository }) => {
  return function useRequestFiles({ requestId, colaboraInstanceId }) {
    return useQuery({
      queryKey: ["vacations/requests/files", { requestId }],
      queryFn: () =>
        getRequestFiles({
          vacationRequestsRepository,
          requestId,
          colaboraInstanceId,
        }),
      enabled: !!requestId && !!colaboraInstanceId,
    });
  };
};
